export const API_LINK: string = "https://api.fda.gov"
export const API_NAME: string = "api.fda.gov"
export default {
  API_LINK,
  API_NAME
}
